import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-static-footer.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * Pager Component
 * @element ghs-static-footer
 */
@customElement('ghs-static-footer')
export class GhsStatic extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
